import { createFetchWithPolicy, FetchPolicyError } from '@emporion/ui'

const toViteNumber = (key: 'VITE_API_TIMEOUT_MS' | 'VITE_API_RETRIES' | 'VITE_API_RETRY_DELAY_MS') => {
  const raw = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env?.[key]
  if (!raw) return null
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

const resolveDefaults = () => ({
  timeoutMs: toViteNumber('VITE_API_TIMEOUT_MS') ?? 10_000,
  retries: toViteNumber('VITE_API_RETRIES') ?? 1,
  retryDelayMs: toViteNumber('VITE_API_RETRY_DELAY_MS') ?? 250,
})

export { FetchPolicyError }
export const fetchWithPolicy = createFetchWithPolicy({ resolveDefaults })

